import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';
import NoSSR from '@material-ui/core/NoSsr';

import { mediaQueries } from 'shared/styles';
import DeliveryErrorModal from 'checkout/modals/delivery-validation-error';
import Header from 'checkout/components/header';
import Sections from 'checkout/components/sections';
import Confirmation from 'checkout/components/confirmation';
import RichTextHtmlWrapper from 'shared/components/rich-text-html-wrapper';
import useCheckoutInit from 'checkout/hooks/use-checkout-init';

function CheckoutContainer() {
  const { order, disclaimerIsBlank, disclaimerTextHtml, viewingDeliveryErrorModal } = useCheckoutInit();

  return (
    <>
      {order.cart && (
        <>
          <Container>
            <CheckoutForm>
              <Header />
              <Sections />
            </CheckoutForm>

            <Overview>
              <Confirmation />
            </Overview>
          </Container>

          {!disclaimerIsBlank && (
            <Disclaimer>
              <RichTextHtmlWrapper html={disclaimerTextHtml} />
            </Disclaimer>
          )}
        </>
      )}

      <NoSSR>{viewingDeliveryErrorModal && <DeliveryErrorModal />}</NoSSR>
    </>
  );
}

export default observer(CheckoutContainer);

const Container = styled.div`
  display: flex;
  justify-content: center;
  max-width: 990px;
  margin: 0 auto;

  @media ${mediaQueries.desktop} {
    display: block;
    max-width: none;
    margin: 0;
  }
`;

const CheckoutForm = styled.div`
  flex: 1 0 0%;
  max-width: 640px;
  min-width: 0;
  padding-left: 0;
  padding-right: 40px;
  padding-bottom: 80px;

  @media ${mediaQueries.desktop} {
    margin: 0 auto;
    padding-right: 0;
    padding-bottom: 30px;
  }

  @media ${mediaQueries.tablet} {
    padding-bottom: 20px;
  }

  @media ${mediaQueries.largePhone} {
    padding-right: 0;
    padding-left: 0;
    max-width: 450px;
    width: 100%;
  }
`;

const Overview = styled.div`
  flex: 0 0 307px;
  padding-right: 0;

  @media ${mediaQueries.largePhone} {
    width: 100%;
  }
`;

const Disclaimer = styled.div`
  border-top: 1px solid var(--dcm-checkout-section-border-color);
  color: var(--dcm-checkout-disclaimer-color, #667882);
  font-family: var(--dcm-font-secondary);
  font-size: 12px;
  line-height: ${18 / 12};
  margin: 0 auto;
  max-width: 800px;
  padding: 4px 20px 80px;
  text-align: center;
  width: 100%;

  @media ${mediaQueries.largePhone} {
    margin-top: 80px;
  }
`;
